import { RouterOutputs, trpc } from "../trpc";

interface Input {
  ids: number[];
  enabled?: boolean;
  membershipStatus?: string;
}

export type Member = RouterOutputs["member"]["members"][string];
export type Members = Record<string, Member>;

export function useMembers({ ids, enabled = true, membershipStatus }: Input) {
  const members = trpc.member.members.useQuery(
    { ids: ids.map(String), membershipStatus },
    {
      enabled: ids.length > 0 && enabled,
      // Members are very unlikely to change and can be cached for a long time
      staleTime: 1000 * 60 * 10,
      trpc: {
        context: {
          // this request can include a huge number of members,
          // use a POST request to avoid URL length limits
          forcePost: true,
        },
      },
    },
  );

  return {
    members: members.data || ({} as Members),
    isLoading: members.isLoading,
    isPending: members.isPending,
  };
}
